import { Button } from '@components/Button'
import { Box } from '@highlight-run/ui/components'
import { ProductType } from '@/graph/generated/schemas'

import * as styles from './style.css'

export const CreateAlertButton = function ({
	type: _type,
}: {
	type: ProductType
}) {
	return null
}

export const Divider: React.FC = () => {
	return <Box cssClass={styles.divider}></Box>
}
